import { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAdminStore } from './store/adminStore';
import AdminSidebar from './components/AdminSidebar';
import AdminHeader from './components/AdminHeader';
import { ToastContainer } from './components/NotificationSystem';

export default function AdminLayout() {
  const { isAuthenticated, token, sidebarOpen, fetchOrdersFromAPI, logout } = useAdminStore();

  // Backend tabanlı admin girişine geçmeden önce oturum açmış olanların
  // localStorage'ında isAuthenticated=true kalmış olabilir ama geçerli bir
  // token'ları yoktur. Bu durumda tüm kayıt işlemleri (ürün/sipariş
  // güncelleme) arka planda sessizce 401 ile reddediliyordu — hiçbir hata
  // görünmeden. Bunu tespit edip zorla çıkış yaptırıyoruz.
  useEffect(() => {
    if (isAuthenticated && !token) {
      logout();
    }
  }, [isAuthenticated, token, logout]);

  // Panelin herhangi bir sayfasında olursa olsun, yeni siparişleri arka planda
  // yakalayıp bildirim gösterebilmek için kısa aralıklarla senkronize et.
  useEffect(() => {
    if (!isAuthenticated) return;
    fetchOrdersFromAPI();
    const interval = setInterval(fetchOrdersFromAPI, 8000);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar />
      <div className={`transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-20'}`}>
        <AdminHeader />
        <main className="p-6">
          <Outlet />
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}
